import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useTimeout, useUpdateEffect, Box, utils } from '@costar/theme-ui';
import { useIsPresent, motion } from 'framer-motion';
import { getToastStyle } from './toast.utils.esm.js';

var toastMotionVariants = {
  initial: function initial(props) {
    var position = props.position;
    var dir = ['top', 'bottom'].includes(position) ? 'y' : 'x';
    var factor = ['top-right', 'bottom-right'].includes(position) ? 1 : -1;
    if (position === 'bottom') factor = 1;
    return _objectSpread2({
      opacity: 0
    }, position.includes('center') ? {} : _defineProperty({}, dir, factor * 24));
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
};
var styleOverrides = {
  pointerEvents: 'auto',
  maxWidth: 560,
  minWidth: 300,
  margin: '0.5rem'
};
var resetCss = {
  display: 'unset'
};
var Toast = function Toast(props) {
  var id = props.id,
    message = props.message,
    onCloseComplete = props.onCloseComplete,
    onRequestRemove = props.onRequestRemove,
    _props$requestClose = props.requestClose,
    requestClose = _props$requestClose === void 0 ? false : _props$requestClose,
    _props$position = props.position,
    position = _props$position === void 0 ? 'bottom' : _props$position,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 5000 : _props$duration,
    description = props.description,
    title = props.title,
    status = props.status;
  var _useState = useState(duration),
    _useState2 = _slicedToArray(_useState, 2),
    delay = _useState2[0],
    setDelay = _useState2[1];
  var delayExecute = useTimeout(delay);
  var isPresent = useIsPresent();
  useUpdateEffect(function () {
    if (!isPresent) {
      onCloseComplete === null || onCloseComplete === void 0 ? void 0 : onCloseComplete();
    }
  }, [isPresent]);
  useUpdateEffect(function () {
    setDelay(duration);
  }, [duration]);
  var onMouseLeave = useCallback(function () {
    return setDelay(duration);
  }, [duration]);
  var close = function close() {
    if (isPresent) onRequestRemove();
  };
  useEffect(function () {
    if (isPresent && requestClose) {
      onRequestRemove();
    }
  }, [isPresent, requestClose, onRequestRemove]);
  delayExecute(function () {
    if (duration !== null) close();
  });
  var style = useMemo(function () {
    return getToastStyle(position);
  }, [position]);
  var custom = useMemo(function () {
    return {
      position: position
    };
  }, [position]);
  return /*#__PURE__*/React.createElement(motion.li, {
    layout: true,
    className: "csg-tui-toast",
    variants: toastMotionVariants,
    initial: "initial",
    animate: "animate",
    exit: "exit",
    onHoverEnd: onMouseLeave,
    custom: custom,
    style: style
  }, /*#__PURE__*/React.createElement(Box, {
    className: "csg-tui-toast__inner",
    style: styleOverrides,
    resetCss: resetCss //overwrite for random display flex injected
  }, utils.isFunction(message) ? message(_objectSpread2(_objectSpread2(_objectSpread2({
    id: id,
    onClose: close
  }, title ? {
    title: title
  } : {}), description ? {
    description: description
  } : {}), status ? {
    status: status
  } : {})) : message));
};
if (utils.__DEV__) {
  Toast.displayName = 'Toast';
}

export { Toast };
//# sourceMappingURL=toast.esm.js.map
